import { RuntimeAccessOptions } from '@/config/runtimeAccess';
import { isInviteSuccessReturn } from '@/components/Onboarding/inviteReturn';

export const isSuccessfulWorkspaceReturn = (searchParams: URLSearchParams): boolean => {
    return searchParams.get('pay_result') === 'success'
        || searchParams.get('onboarding_success') === 'true'
        || isInviteSuccessReturn(searchParams);
};

export const isOnboardingSuccessfulWorkspaceReturn = (searchParams: URLSearchParams): boolean => {
    return searchParams.get('onboarding_success') === 'true';
};

export const shouldPreserveWorkspaceReturnParamsForPaymentResult = (
    searchParams: URLSearchParams,
): boolean => {
    return searchParams.get('pay_result') === 'success';
};

export const shouldRetryMissingWorkspaceAfterOnboardingReturn = (
    searchParams: URLSearchParams,
    pathname: string,
    options?: RuntimeAccessOptions,
): boolean => {
    void pathname;
    void options;
    return isOnboardingSuccessfulWorkspaceReturn(searchParams);
};

export const getPendingWorkspaceReturnId = (
    searchParams: URLSearchParams,
    storedWorkspaceId?: string | null,
): string | null => {
    if (!isSuccessfulWorkspaceReturn(searchParams)) {
        return null;
    }

    return searchParams.get('workspace_id') || storedWorkspaceId || null;
};
